<template>
    <v-table    ref="table"
                :fields="fields"
                :settings="false"
                :items-provider="provider"
                :buttons="buttons"
                :row-class="i => i.Locked ? 'bg-light-secondary':null">
            <template #additional-actions>
                <div class="row">
                    <div class="col-md-2 mb-1 mb-md-0">
                        <select class="form-control" v-model="month">
                            <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                        </select>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">
                        <select class="form-control" v-model="year">
                            <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                        </select>
                    </div>
                    <div class="col-md-auto mb-1 mb-md-0">
                        <button class="btn btn-success btn-block" v-on:click="$refs.table.refresh()">
                            Sorgula
                        </button>
                    </div>
                </div>
            </template>
        </v-table>
</template>

<script>
import moment from 'moment'
import EmployeeOperationsApi from '@/api/employee-operations'

export default{
    props:{
        months:Array,
    },
    data(){
        return {
            month:moment().month() + 1,
            year:moment().year(),
            years:[],
            fields:[
                {name:"Durum", component:true,componentOptions:{name:"score-lock-status/ScoreLockStatus"}},
                {name:'Şube',thClass:'w-100',key:'BranchName'},
                {name:'Son İşlem Tarihi',key:'ProcessDateStr'}
            ],
            buttons:[
                { text:"Puantajı Kilitle",key:"lock",icon:"LockIcon",variant:"dark",action:this.lock, condition:(i) => !i.Locked},
                { text:"Puantaj Kilidini kaldır",key:"lock",icon:"UnlockIcon",variant:"secondary",action:this.lock, condition:(i) => i.Locked},
            ]
        }
    },
    mounted(){
        this.getCurrentYear()
        this.configureYears()
        this.getCurrentMonth()
    },
    methods:{
        provider(){
            return EmployeeOperationsApi.Score.LockStatusTable({
                Month:this.month,
                Year:this.year,
                Driver:false
            })
        },
        getCurrentYear(){
            this.year = moment().format('YYYY')
            this.showingYear = this.year
        },
        configureYears(){
            let years = []
            let year = 2015
            while(year <= this.year){
                years.push(year)
                year ++
            }
            this.years = years
        },
        getCurrentMonth(){
            let current = moment().month() + 1
            this.month = this.months.find(m=>m.index == current)?.index || 0
            this.showingMonth = this.month
        },
        lock(item){
            this.$refs.table.rowLoading(true)
            EmployeeOperationsApi.Score.ChangeLockStatus({
                "Month": this.month,
                "Year": this.year,
                "BranchId": item.BranchId,
                "Driver": false,
                "Lock": !item.Locked
            }).then(res => {
                this.$result(res)
                this.$refs.table.rowLoading(false)
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
            }).catch(err => {
                this.$result(null,err)
                this.$refs.table.rowLoading(false)
            })
        }
    }
}
</script>